export const enum ChatEvent {
    ChatCreated = 'ChatCreated',
}

export interface ChatCreatedData {
    body: {
        patientId: string;
    };
    name: ChatEvent.ChatCreated;
    entityId: string;
    entityType: 'Chat';
    occurredOn: string;
}
